import { Component, ChangeDetectionStrategy } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslatePipe } from "@ngx-translate/core";

export interface AskUnbridgeDialogContext {
}

@Component({
    selector: "my-telegram-ask-unbridge",
    templateUrl: "./ask-unbridge.component.html",
    styleUrls: ["./ask-unbridge.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [TranslatePipe]
})
export class TelegramAskUnbridgeComponent {

    constructor(public modal: NgbActiveModal) {
    }

    public unbridgeAndContinue(): void {
        this.modal.close({unbridge: true});
    }

    public cancel(): void {
        this.modal.close({unbridge: false});
    }
}
